import React, { useEffect } from "react";
import { MdInventory, MdRefresh } from "react-icons/md";
import styles from "./EmptyCatalogView.module.scss";
import { EmptyState } from "../../../common/components/emptyState/EmptyState";
import { useScreenTracking } from "../../../common/hooks/useScreenTracking";

interface EmptyCatalogViewProps {
  onRetry?: () => void;
}

export const EmptyCatalogView: React.FC<EmptyCatalogViewProps> = ({
  onRetry,
}) => {
  const { trackEmptyCatalog } = useScreenTracking();

  useEffect(() => {
    trackEmptyCatalog();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <EmptyState
          icon={MdInventory}
          title="Каталог пуст"
          description="Администратор еще не добавил товары в систему. Данные появятся после наполнения каталога."
        />

        {onRetry && (
          <button className={styles.retryButton} onClick={onRetry}>
            <MdRefresh size={20} />
            <span>Обновить</span>
          </button>
        )}
      </div>

      <p className={styles.offlineMessage}>
        Работа доступна после загрузки каталога
      </p>
    </div>
  );
};
